import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Credencial } from '../models/credencial.model';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class LoginService {

  private strAction = 'api/Login';

  constructor(private http: HttpClient) { }

  autenticar(Credencial : Credencial) {
    return this.http.post<Credencial>(`${environment.TrustCRMApiHost}${this.strAction}/Autenticar` , Credencial)
  }

}
